module.exports = __webpack_public_path__ + "static/img/video_img1.b1ae83fa.jpg";